@if (useLucide()) {
  <lucide-icon
    [name]="lucideIconName()"
    [size]="lucideSize()"
    [strokeWidth]="2"
    [color]="fill || 'currentColor'"
    [ngClass]="customClass"
    [ngStyle]="{
      'color': fill || 'currentColor'
    }"
    (click)="clickEvent.emit()"
    [ngbTooltip]="tooltip || null"
    [placement]="placement"
    [openDelay]="300"
  />
} @else {
  <mat-icon
    svgIcon="calio-{{iconType()}}-icon"
    class="tw-flex {{customClass}}"
    [ngStyle]="{
      'height': height,
      'width': width,
      'fill': fill
    }"
    (click)="clickEvent.emit()"
    [ngbTooltip]="tooltip || null"
    [placement]="placement"
    [openDelay]="300"
  />
}
